/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AgencyCreationRequest } from './';
import {
    AgencyCreationRequestFromJSON,
    AgencyCreationRequestFromJSONTyped,
    AgencyCreationRequestToJSON,
} from './';
import type { FreelancerCreationRequest } from './';
import {
    FreelancerCreationRequestFromJSON,
    FreelancerCreationRequestFromJSONTyped,
    FreelancerCreationRequestToJSON,
} from './';
import type { ProjectDetailsCreationRequest } from './';
import {
    ProjectDetailsCreationRequestFromJSON,
    ProjectDetailsCreationRequestFromJSONTyped,
    ProjectDetailsCreationRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepatriationOpportunityCreationRequest
 */
export interface RepatriationOpportunityCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityCreationRequest
     */
    clientIdentityId: string;
    /**
     * 
     * @type {Array<FreelancerCreationRequest>}
     * @memberof RepatriationOpportunityCreationRequest
     */
    freelancers?: Array<FreelancerCreationRequest>;
    /**
     * 
     * @type {Array<AgencyCreationRequest>}
     * @memberof RepatriationOpportunityCreationRequest
     */
    agencies?: Array<AgencyCreationRequest>;
    /**
     * 
     * @type {ProjectDetailsCreationRequest}
     * @memberof RepatriationOpportunityCreationRequest
     */
    projectDetails: ProjectDetailsCreationRequest;
}

/**
 * Check if a given object implements the RepatriationOpportunityCreationRequest interface.
 */
export function instanceOfRepatriationOpportunityCreationRequest(value: object): value is RepatriationOpportunityCreationRequest {
    if (!('clientIdentityId' in value) || value['clientIdentityId'] === undefined) return false;
    if (!('projectDetails' in value) || value['projectDetails'] === undefined) return false;
    return true;
}

export function RepatriationOpportunityCreationRequestFromJSON(json: any): RepatriationOpportunityCreationRequest {
    return RepatriationOpportunityCreationRequestFromJSONTyped(json, false);
}

export function RepatriationOpportunityCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientIdentityId': json['clientIdentityId'],
        'freelancers': json['freelancers'] == null ? undefined : ((json['freelancers'] as Array<any>).map(FreelancerCreationRequestFromJSON)),
        'agencies': json['agencies'] == null ? undefined : ((json['agencies'] as Array<any>).map(AgencyCreationRequestFromJSON)),
        'projectDetails': ProjectDetailsCreationRequestFromJSON(json['projectDetails']),
    };
}

export function RepatriationOpportunityCreationRequestToJSON(value?: RepatriationOpportunityCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientIdentityId': value['clientIdentityId'],
        'freelancers': value['freelancers'] == null ? undefined : ((value['freelancers'] as Array<any>).map((v) => FreelancerCreationRequestToJSON(v))),
        'agencies': value['agencies'] == null ? undefined : ((value['agencies'] as Array<any>).map((v) => AgencyCreationRequestToJSON(v))),
        'projectDetails': ProjectDetailsCreationRequestToJSON(value['projectDetails']),
    };
}

